import { Button, Card, Col, Form, Input, Row, Select, DatePicker, Space, theme } from 'antd';
import { useEffect, useState } from 'react';
import { computeButtonColLayout, filterFormGridLayout, filterFormItemLayout, filterFormItemStyle } from '@utils/property';

const TOTAL_FIELD_COUNT = 5;
const { RangePicker } = DatePicker;

export default function CheckOrganizationsFilterPanel({ filter, onFinish, onReset }) {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [timePicker, setTimePicker] = useState([]);
    const buttonColLayout = computeButtonColLayout(TOTAL_FIELD_COUNT);

    useEffect(() => {
        form.setFieldsValue({
            code: filter.code,
            name: filter.name,
            belongsUnitName: filter.belongsUnitName,
            type: filter.type,
            timePicker: filter.timePicker,
        });
        if (filter.createdStartAt && filter.createdEndAt) {
            setTimePicker([filter.createdStartAt, filter.createdEndAt]);
        }
    }, [filter, form]);

    const handleChangeTime = (_value, dateString) => {
        setTimePicker(dateString);
    };

    const handleReset = () => {
        form.resetFields();
        setTimePicker([]);
        onReset();
    };

    const handleFinish = values => {
        const payload = { ...values };
        if (timePicker.length === 2) {
            payload.createdStartAt = timePicker[0];
            payload.createdEndAt = timePicker[1];
        }
        onFinish(payload);
    };

    return (
        <Card
            size="small"
            className="healthclass-check-filter-panel"
            style={{
                marginBottom: token.marginLG,
                border: `1px solid ${token.colorBorderSecondary}`,
                background: token.colorFillAlter,
            }}
        >
            <Form {...filterFormItemLayout} form={form} onFinish={handleFinish} autoComplete="off" requiredMark={false}>
                <Row gutter={[16, 16]}>
                    <Col {...filterFormGridLayout}>
                        <Form.Item label="学苑ID" name="code" style={filterFormItemStyle}>
                            <Input allowClear placeholder="学苑ID" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="学苑名称" name="name" style={filterFormItemStyle}>
                            <Input allowClear placeholder="学苑名称" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="所属主体" name="belongsUnitName" style={filterFormItemStyle}>
                            <Input allowClear placeholder="所属主体" />
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="学苑类型" name="type" style={filterFormItemStyle}>
                            <Select allowClear placeholder="请选择">
                                <Select.Option value={2}>正式</Select.Option>
                                <Select.Option value={1}>试用</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col {...filterFormGridLayout}>
                        <Form.Item label="申请时间" name="timePicker" style={filterFormItemStyle}>
                            <RangePicker allowClear onChange={handleChangeTime} showTime />
                        </Form.Item>
                    </Col>

                    <Col {...buttonColLayout}>
                        <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                            <Space size="small">
                                <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                    检索
                                </Button>
                                <Button type="default" onClick={handleReset}>
                                    重置
                                </Button>
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}
